import React from 'react';

import Tipsy from 'zoomforth_component_lib/tipsy.jsx';
import { ErrorIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

import get from 'lodash/get';
import includes from 'lodash/includes';

import {
  THEME_STYLESHEET_V1,
  THEME_STYLESHEET_V2,
  THEME_STYLESHEET_V3,
  THEME_STYLESHEET_V4
} from '../themes_const_shared/theme_stylesheet_versions.js';

import {
  ACCESSIBILITY_DESCRIPTION
} from './accessibility.js';

export const SITE_VIEWER_V1 = 1;
export const SITE_VIEWER_V2 = 2;

export const ALL_SITE_VIEWER_VERSIONS = [
  SITE_VIEWER_V1,
  SITE_VIEWER_V2
];

export const LATEST_SITE_VIEWER_VERSION = SITE_VIEWER_V2;

export const SITE_VIEWER_VERSIONS_META = {
  [SITE_VIEWER_V1]: {
    intro: 'Enables multi-section subpages',
    description: 'This version of a Zoomforth site introduces a way to create sections and subpages in order to build more complex sites.',
    compatible_theme_stylesheets: [
      THEME_STYLESHEET_V1,
      THEME_STYLESHEET_V2,
      THEME_STYLESHEET_V3
    ]
  },
  [SITE_VIEWER_V2]: {
    intro: 'An upgrade is available that will introduce new accessibility features to your site.',
    description: ACCESSIBILITY_DESCRIPTION,
    compatible_theme_stylesheets: [
      THEME_STYLESHEET_V4
    ]
  }
};

const AccessibleTooltip = ()=> (
  <Tipsy content={ACCESSIBILITY_DESCRIPTION} placement="right">
    <span className="accessible-tooltip-msg">
      accessible
    </span>
  </Tipsy>
);

export const LatestSiteVersionViewerUpgradeMsg = ({ onUpgradeClick })=> (
  <div className="site-viewer-version-upgrade-wrapper">
    <div className="site-viewer-version-upgrade-header">
      <ErrorIcon /> <span>Make your site accessible</span>
    </div>

    <div className="site-viewer-version-upgrade-body">
      Follow the step by step guide to make your site <AccessibleTooltip />
    </div>

    <button className="site-viewer-version-upgrade-btn" onClick={onUpgradeClick}>
      Upgrade
    </button>
  </div>
);

const _getSiteViewerVersionMeta = (siteViewerVersion)=> {
  if (!includes(ALL_SITE_VIEWER_VERSIONS, siteViewerVersion)) {
    throw new Error('Site viewer version does not exist');
  }

  return get(SITE_VIEWER_VERSIONS_META, `${siteViewerVersion}`);
};

export const getCompatibleStylesheetVersions = (siteViewerVersion)=>
  _getSiteViewerVersionMeta(siteViewerVersion).compatible_theme_stylesheets;

export const getSiteViewerVersionIntro = (siteViewerVersion)=>
  _getSiteViewerVersionMeta(siteViewerVersion).intro;

export const getSiteViewerVersionDescription = (siteViewerVersion)=>
  _getSiteViewerVersionMeta(siteViewerVersion).description;

export const getIsLatestSiteViewerVersion = (siteViewerVersion)=>
  siteViewerVersion === LATEST_SITE_VIEWER_VERSION;
